const enum BasketReducerActions {
    CHANGE_UPSALE_QUANTITY = "CHANGE_UPSALE_QUANTITY",
    CHANGE_TICKET_QUANTITY = "CHANGE_TICKET_QUANTITY",
    CHANGE_TICKET_UPSALE_QUANTITY = "CHANGE_TICKET_UPSALE_QUANTITY",
    CLEAR_EVENT = "CLEAR_EVENT",
    INCREASE_GUESTS = "INCREASE_GUESTS",
    DECREASE_GUESTS = "DECREASE_GUESTS",
    SET_EVENT = "SET_EVENT",
    SET_GUESTS = "SET_GUESTS",
    SET_VIEW = "SET_VIEW",
    SET_SINGLE_TICKET = "SET_SINGLE_TICKET",
    TOGGLE_TICKET = "TOGGLE_TICKET",
}

export default BasketReducerActions;
